import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  tryFreeForXDays: {
    defaultMessage: 'Try Free for {formattedDays} {trialLengthInDays, plural, one {Day} other {Days}}',
    description: 'The Call To Action text so user may confirm to trial an AddOn',
    id: 'w4QITS',
  },
  reactivateAddOn: {
    defaultMessage: 'Reactivate {addOnName}',
    description: 'The Call To Action text so user may confirm they want to re-add the AddOn',
    id: 'aC6w7K',
  },
  activateAddOn: {
    defaultMessage: 'Activate {addOnName}',
    description: 'The Call To Action button text so user may confirm they want to add the AddOn',
    id: 'OnZ7q1',
  },
  activateAndConfigureReturnRabbit: {
    defaultMessage: 'Activate and Configure account',
    description: 'The Call To Action button text so user may confirm they want to add Return Rabbit',
    id: 'PlND44',
  },
  activateAddOnSuccessNotificationTitle: {
    defaultMessage: '{addOnName} Activated',
    description: 'Title of the notification that will show to inform the user they successfully activated an addon.',
    id: 'kdur8f',
  },
  activateAddOnSuccessNotificationText: {
    defaultMessage: 'You have successfully activated {addOnName}. Configure the feature settings to start using it.',
    description: 'Body text of the notification that will show to inform the user they successfully activated an addon.',
    id: 'CToFSk',
  },
  shipstationV2AddOnSuccessNotificationText: {
    defaultMessage: 'Configure the feature settings to start using it.',
    id: 'xj7PcR',
    description: 'Body text of the notification that will show to inform the user they successfully activated Shipstation V2.',
  },
  returnRabbitAddOnSuccessNotificationTitle: {
    defaultMessage: "You've successfully activated the Return Rabbit add-on. Open Return Rabbit to get started.",
    description: 'Body text of the notification that will show to inform the user they successfully activated Return Rabbit.',
    id: '4IFV5P',
  },
  configureAccount: {
    defaultMessage: 'Configure Account',
    id: 'KWnW/7',
    description: 'Button text to inform the user to configure the Return Rabbit feature.',
  },
  reactivateAddOnSuccessNotificationTitle: {
    defaultMessage: '{addOnName} Reactivated',
    description: 'Title of the notification that will show to inform the user they successfully reactivated an addon.',
    id: 'Ea702I',
  },
  reactivateAddOnSuccessNotificationText: {
    defaultMessage: '{addOnName} has been reactivated. You may continue to use this feature without disruption.',
    description: 'Body text of the notification that will show to inform the user they successfully activated an addon.',
    id: 'KqAu37',
  },
  upgradeOnPaymentsAndSubscriptions: {
    defaultMessage: 'Upgrade on Payment and Subscriptions',
    description: 'Button text to inform the user to confirm the feature.',
    id: 'JJEbi9',
  },
  activateAddOnFailureNotificationTitle: {
    defaultMessage: '{addOnName} Failed to Activate',
    id: 'DMc3LV',
    description: 'Title of the notification that will show to inform the user there was a problem deactivating an addon.',
  },
  returnRabbitFailureNoStoresNotification: {
    defaultMessage: 'You must have at least one active store connection to activate the Return Rabbit add-on.',
    description:
      'Body text of the notification that will show to inform the user that they must have at least one store to activate Return Rabbit.',
    id: 'JqZSSx',
  },
  storeSetup: {
    defaultMessage: 'Store Setup',
    id: 'Sf1e+v',
    description: 'link text to inform the user to setup their store.',
  },
  apiSettings: {
    defaultMessage: 'API Settings',
    id: 'Jxybqg',
    description: 'link text to inform the user to setup their API Key',
  },
  activateAddOnFailureNotificationText: {
    defaultMessage: 'ShipStation could not activate {addOnName} at this time. Please try again.',
    id: 'qsLa1l',
    description: 'Body text of the notification that will show to inform the use that there was a problem deactivating an addon.',
  },
  retryButton: {
    description: 'button label for the Retry button',
    defaultMessage: 'Retry',
    id: 'aaITTJ',
  },
  contactSupportLink: {
    description: 'label for the link that will take the user to an external site so they can contact support',
    defaultMessage: 'Contact Support',
    id: '+vTbsh',
  },
});
